import React from "react";
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Outlet,
} from "react-router-dom";
import PrivateRoute from "../utilities/PrivateRoute";
import { useTokenExpiration } from "../utilities/useTokenExpiration";
import { useFirebaseMessaging } from "../hooks/useFirebaseMessaging";
import { useSessionKeepAlive } from "../hooks/useSessionKeepAlive";

// import Hep from "./hep/Hep";
import Utils from "./utils/Utils";
import Bethlehem from "./bethlehem/Bethlehem";
import { ViewMenuCount, UpdateMenuCount } from "./bethlehem";
import {
	ViewAllMembers,
	Member,
	ViewMemberDetail,
	EditMemberData,
	AddMember,
	AddMemberStep2,
	ViewDisciplinaryRecords,
	ViewTransferRecords,
	BulkEditMembers,
	ManageEmployeeTeams,
	AssignEmployeeTeamMembers,
	ManageEmployeeInfo,
} from "./member";

// import {
// 	Jubo,
// 	AddJuboDate,
// 	DownloadXml,
// 	GetAnnounceData,
// 	GetChoirData,
// 	GetLogosData,
// 	GetSermonData,
// 	ShowContentsFlag,
// } from "./hep/jubo";

import {
	ViewAccessedCars,
	ViewAccessedCarsHistory,
	AddAccessedCar,
	EditAccessedCar,
} from "./utils/vehicle/accessed_car";

import {
	ViewEtarCars,
	AddEtarCar,
	EditEtarCar,
} from "./utils/vehicle/etal_car";

import {
	ApplyRent,
	ViewRentApplication,
	ViewRentalSanctuarySchedule,
	BookRentalSanctuary,
	BulkRentSchedule,
	LookupRentSanctuaryApplications,
} from "./utils/rent_sanctuary";

import {
	ApplyForAnnualLeave,
	ApplyForExcuse,
	ApplyForBusinessTrip,
	ApplyForSpecialLeave,
	ApplyForMenstrualLeave,
	LeaveApprovals,
	ViewLeaveApplications,
	ManageLeaveBalance,
	MyLeaveApplications,
	LeaveApplicationStatus,
	MyAttendanceStatus,
} from "./utils/leave";

import {
	Attendance,
	MonthlyAttendance,
	DailyAttendance,
	UserAttendance,
	DawnWorshipAttendance,
	AttendanceSettings,
	HolidayHalfDayManage,
	LeaveBalanceManage,
	LeaveUsagePlanManage,
	ApprovalRouteManage,
	ApprovalRouteAssignments,
} from "./attendance";

import {
	CreateCashDisbursementVoucher,
	MyCashDisbursementVouchers,
	OfficeCashDisbursementReview,
	AccountingApprovedCashDisbursementList,
} from "./utils/cash_disbursement";

import {
	ViewRentalCarSchedule,
	ViewMaintenanceCarSchedule,
	PublicRentalCarSchedulePage,
	ApplyRentalCar,
	ViewRentalCarApplications,
} from "./utils/vehicle/rent_car";
import VehicleInsuranceList from "./utils/vehicle/inspection/VehicleInsuranceList";
import { ViewCarTypes } from "./utils/vehicle/car_type";

import Cma from "./cma/Cma";
import CourseVideoListPage from "./cma/CourseVideoListPage";
import VideoPlayerPage from "./cma/VideoPlayerPage";
import CourseExamPage from "./cma/CourseExamPage";
import AdminCourseExamPage from "./cma/AdminCourseExamPage";
import AdminCourseDetailPage from "./cma/AdminCourseDetailPage";
import AdminPage from "./cma/AdminPage";
import AddBulkEnrollmentsPage from "./cma/AddBulkEnrollmentsPage";

import { Login, Logout, ChangeInitialPassword } from "./auth";
import Header from "./Header";
import Home from "./Home";
import PageTitle from "./PageTitle";

// Wrapper component to handle token expiration inside Router context
const AppContent = () => {
	// Handle token expiration events
	useTokenExpiration();
	useFirebaseMessaging();
	useSessionKeepAlive();

	return (
		<>
			{/* 기본 제목 설정 - 각 페이지에서 PageTitle을 사용하지 않으면 기본값 사용 */}
			<PageTitle />
			<Header />
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/login" element={<Login />} />
				<Route path="/logout" element={<Logout />} />
				<Route
					path="/change-initial-password"
					element={
						<PrivateRoute>
							<ChangeInitialPassword />
						</PrivateRoute>
					}
				/>
				{/* <Route path="/hep" element={<Hep />}>
				<Route path="jubo" element={<Jubo />}>
					<Route
						path="add-jubo-date"
						element={
							<AddJuboDate />
						}></Route>
					<Route
						path="download-xml"
						element={
							<DownloadXml />
						}></Route>
					<Route
						path="get-announce-data"
						element={
							<GetAnnounceData />
						}></Route>
					<Route
						path="get-choir-data"
						element={
							<GetChoirData />
						}></Route>
					<Route
						path="get-logos-data"
						element={
							<GetLogosData />
						}></Route>
					<Route
						path="get-sermon-data/:preacher"
						element={
							<GetSermonData />
						}></Route>
					<Route
						path="show-contents-flag"
						element={
							<ShowContentsFlag />
						}></Route>
				</Route>
			</Route> */}

				<Route
					path="/bethlehem"
					element={<Bethlehem />}>
					<Route
						path="view-menu-count"
						element={
							<ViewMenuCount />
						}></Route>
					<Route
						path="update-menu-count"
						element={
							<UpdateMenuCount />
						}></Route>
				</Route>
				<Route path="/member" element={<Member />}>
					<Route
						path="view-all-members"
						element={
							<PrivateRoute
								requiredGroups={[
									"office",
								]}>
								<ViewAllMembers />
							</PrivateRoute>
						}></Route>
					<Route
						path="view-member-detail/:id"
						element={
							<PrivateRoute
								requiredGroups={[
									"office",
								]}>
								<ViewMemberDetail />
							</PrivateRoute>
						}></Route>
					<Route
						path="edit-member/:id"
						element={
							<PrivateRoute
								requiredGroups={[
									"office",
								]}>
								<EditMemberData />
							</PrivateRoute>
						}></Route>
					<Route
						path="add-member"
						element={
							<PrivateRoute
								requiredGroups={[
									"office",
								]}>
								<AddMember />
							</PrivateRoute>
						}></Route>
					<Route
						path="add-member-step2/:id"
						element={
							<PrivateRoute
								requiredGroups={[
									"office",
								]}>
								<AddMemberStep2 />
							</PrivateRoute>
						}></Route>
					<Route
						path="bulk-edit-members"
						element={
							<PrivateRoute
								requiredGroups={[
									"office",
								]}>
								<BulkEditMembers />
							</PrivateRoute>
						}></Route>
					<Route
						path="view-disciplinary-records"
						element={
							<PrivateRoute
								requiredGroups={[
									"office",
								]}>
								<ViewDisciplinaryRecords />
							</PrivateRoute>
						}></Route>
					<Route
						path="view-transfer-records"
						element={
							<PrivateRoute
								requiredGroups={[
									"office",
								]}>
								<ViewTransferRecords />
							</PrivateRoute>
						}></Route>
					<Route
						path="manage-employee-teams"
						element={
							<PrivateRoute
								requiredGroups={[
									"office_team",
									"office_leave",
								]}>
								<ManageEmployeeTeams />
							</PrivateRoute>
						}
					/>
					<Route
						path="assign-employee-team-members"
						element={
							<PrivateRoute
								requiredGroups={[
									"office_team",
									"office_leave",
								]}>
								<AssignEmployeeTeamMembers />
							</PrivateRoute>
						}
					/>
					<Route
						path="manage-employee-info"
						element={
							<PrivateRoute
								requiredGroups={[
									"office_leave",
								]}>
								<ManageEmployeeInfo />
							</PrivateRoute>
						}
					/>
				</Route>
				<Route path="/utils" element={<Utils />}>
					<Route
						path="accessed-car"
						element={<Outlet />}>
						<Route
							path="view-accessed-cars"
							element={
								<PrivateRoute
									requiredGroups={[
										"office",
									]}>
									<ViewAccessedCars />
								</PrivateRoute>
							}></Route>
						<Route
							path="view-accessed-cars-history"
							element={
								<PrivateRoute
									requiredGroups={[
										"office",
									]}>
									<ViewAccessedCarsHistory />
								</PrivateRoute>
							}></Route>
						<Route
							path="add-accessed-car"
							element={
								<PrivateRoute
									requiredGroups={[
										"office",
									]}>
									<AddAccessedCar />
								</PrivateRoute>
							}></Route>
						<Route
							path="edit-accessed-car/:id"
							element={
								<PrivateRoute
									requiredGroups={[
										"office",
									]}>
									<EditAccessedCar />
								</PrivateRoute>
							}></Route>
					</Route>
					<Route
						path="etal-car"
						element={<Outlet />}>
						<Route
							path="add-etar-car"
							element={
								<PrivateRoute
									requiredGroups={[
										"office",
									]}>
									<AddEtarCar />
								</PrivateRoute>
							}></Route>
						<Route
							path="view-etar-cars"
							element={
								<PrivateRoute
									requiredGroups={[
										"office",
									]}>
									<ViewEtarCars />
								</PrivateRoute>
							}></Route>
						<Route
							path="edit-etar-car/:id"
							element={
								<PrivateRoute
									requiredGroups={[
										"office",
									]}>
									<EditEtarCar />
								</PrivateRoute>
							}></Route>
					</Route>
					<Route
						path="rent-sanctuary"
						element={<Outlet />}>
						<Route
							path="apply-rent"
							element={
								<PrivateRoute
									requiredGroups={[
										"office_sanctuary",
									]}>
									<ApplyRent />
								</PrivateRoute>
							}></Route>
						<Route
							path="view-rent-application"
							element={
								<PrivateRoute
									requiredGroups={[
										"office",
										"office_sanctuary",
									]}>
									<ViewRentApplication />
								</PrivateRoute>
							}></Route>
						<Route
							path="bulk-rent-schedule"
							element={
								<PrivateRoute
									requiredGroups={[
										"office_sanctuary",
									]}>
									<BulkRentSchedule />
								</PrivateRoute>
							}></Route>
						<Route
							path="view-rental-sanctuary-schedule"
							element={
								<PrivateRoute
									requiredGroups={[
										"office",
										"office_sanctuary",
									]}>
									<ViewRentalSanctuarySchedule />
								</PrivateRoute>
							}></Route>
						<Route
							path="book-sanctuary"
							element={
								<BookRentalSanctuary />
							}></Route>
						<Route
							path="lookup-applications"
							element={
								<LookupRentSanctuaryApplications />
							}></Route>
					</Route>
					<Route
						path="rent-cars/share/:shareToken"
						element={
							<PublicRentalCarSchedulePage />
						}
					/>
					<Route
						path="rent-cars/apply"
						element={<ApplyRentalCar />}
					/>
					<Route
						path="rent-cars/applications"
						element={
							<PrivateRoute
								requiredGroups={[
									"office",
								]}>
								<ViewRentalCarApplications />
							</PrivateRoute>
						}
					/>
					<Route
						path="rent-cars/maintenance"
						element={
							<PrivateRoute
								requiredGroups={[
									"office",
								]}>
								<ViewMaintenanceCarSchedule />
							</PrivateRoute>
						}
					/>
					<Route
						path="rent-cars"
						element={
							<PrivateRoute
								requiredGroups={[
									"office",
								]}>
								<ViewRentalCarSchedule />
							</PrivateRoute>
						}
					/>
					<Route
						path="vehicle-insurance"
						element={
							<PrivateRoute
								requiredGroups={[
									"office",
								]}>
								<VehicleInsuranceList />
							</PrivateRoute>
						}
					/>
					<Route
						path="car-types"
						element={
							<PrivateRoute
								requiredGroups={[
									"office",
								]}>
								<ViewCarTypes />
							</PrivateRoute>
						}
					/>
					<Route
						path="apply-for-leave"
						element={
							<PrivateRoute
								requiredClassifications={[
									"교역자",
									"교직원",
								]}>
								<ApplyForAnnualLeave />
							</PrivateRoute>
						}></Route>
					<Route
						path="cash-disbursement/create"
						element={
							<PrivateRoute
								requiredClassifications={[
									"교역자",
									"교직원",
								]}>
								<CreateCashDisbursementVoucher />
							</PrivateRoute>
						}
					/>
					<Route
						path="cash-disbursement/edit/:id"
						element={
							<PrivateRoute
								requiredClassifications={[
									"교역자",
									"교직원",
								]}>
								<CreateCashDisbursementVoucher />
							</PrivateRoute>
						}
					/>
					<Route
						path="cash-disbursement/my-list"
						element={
							<PrivateRoute
								requiredClassifications={[
									"교역자",
									"교직원",
								]}>
								<MyCashDisbursementVouchers />
							</PrivateRoute>
						}
					/>
					<Route
						path="cash-disbursement/office-review"
						element={
							<PrivateRoute
								requiredGroups={[
									"office_director",
									"office_deputy-director",
								]}>
								<OfficeCashDisbursementReview />
							</PrivateRoute>
						}
					/>
					<Route
						path="cash-disbursement/accounting"
						element={
							<PrivateRoute
								requiredGroups={[
									"accounting",
								]}>
								<AccountingApprovedCashDisbursementList />
							</PrivateRoute>
						}
					/>
					<Route
						path="leave"
						element={<Outlet />}>
						<Route
							path="my-status"
							element={
								<PrivateRoute
									requiredClassifications={[
										"교역자",
										"교직원",
									]}>
									<MyAttendanceStatus />
								</PrivateRoute>
							}
						/>
						<Route
							path="apply-annual"
							element={
								<PrivateRoute
									requiredClassifications={[
										"교역자",
										"교직원",
									]}>
									<ApplyForAnnualLeave />
								</PrivateRoute>
							}
						/>
						<Route
							path="apply-excuse"
							element={
								<PrivateRoute
									requiredClassifications={[
										"교역자",
										"교직원",
									]}>
									<ApplyForExcuse />
								</PrivateRoute>
							}
						/>
						<Route
							path="apply-trip"
							element={
								<PrivateRoute
									requiredClassifications={[
										"교역자",
										"교직원",
									]}>
									<ApplyForBusinessTrip />
								</PrivateRoute>
							}
						/>
						<Route
							path="apply-family-event"
							element={
								<PrivateRoute
									requiredClassifications={[
										"교역자",
										"교직원",
									]}>
									<ApplyForSpecialLeave />
								</PrivateRoute>
							}
						/>
						<Route
							path="apply-sick"
							element={
								<PrivateRoute
									requiredClassifications={[
										"교역자",
										"교직원",
									]}>
									<ApplyForSpecialLeave />
								</PrivateRoute>
							}
						/>
						<Route
							path="apply-menstrual"
							element={
								<PrivateRoute
									requiredClassifications={[
										"교역자",
										"교직원",
									]}>
									<ApplyForMenstrualLeave />
								</PrivateRoute>
							}
						/>
						<Route
							path="approvals"
							element={
								<PrivateRoute
									requiredClassifications={[
										"교역자",
										"교직원",
									]}>
									<LeaveApprovals />
								</PrivateRoute>
							}
						/>
						<Route
							path="my-applications"
							element={
								<PrivateRoute
									requiredClassifications={[
										"교역자",
										"교직원",
									]}>
									<MyLeaveApplications />
								</PrivateRoute>
							}></Route>
						<Route
							path="view-applications"
							element={
								<PrivateRoute
									requiredGroups={[
										"office_leave",
									]}>
									<ViewLeaveApplications />
								</PrivateRoute>
							}></Route>
						<Route
							path="application-status"
							element={
								<PrivateRoute
									requiredGroups={[
										"office_leave",
									]}>
									<LeaveApplicationStatus />
								</PrivateRoute>
							}></Route>
						<Route
							path="manage-balance"
							element={
								<PrivateRoute
									requiredGroups={[
										"office_leave",
									]}>
									<ManageLeaveBalance />
								</PrivateRoute>
							}></Route>
					</Route>
				</Route>

				<Route
					path="/attendance-view/monthly"
					element={
						<PrivateRoute
							requiredGroups={[
								"office_director",
								"church_leader",
							]}>
							<MonthlyAttendance
								readOnly
							/>
						</PrivateRoute>
					}
				/>

				<Route
					path="/attendance"
					element={
						<PrivateRoute
							requiredGroups={[
								"office_leave",
							]}>
							<Attendance />
						</PrivateRoute>
					}>
					<Route
						index
						element={<MonthlyAttendance />}
					/>
					<Route
						path="monthly"
						element={<MonthlyAttendance />}
					/>
					<Route
						path="daily"
						element={<DailyAttendance />}
					/>
					<Route
						path="user"
						element={<UserAttendance />}
					/>
					<Route
						path="dawn-worship"
						element={
							<DawnWorshipAttendance />
						}
					/>
					<Route
						path="settings"
						element={<AttendanceSettings />}
					/>
					<Route
						path="leave-applications"
						element={
							<ViewLeaveApplications
								hideNavigation
							/>
						}
					/>
					<Route
						path="leave-balance"
						element={<LeaveBalanceManage />}
					/>
					<Route
						path="leave-plans"
						element={
							<LeaveUsagePlanManage />
						}
					/>
					<Route
						path="holiday-half-day"
						element={
							<HolidayHalfDayManage />
						}
					/>
					<Route
						path="approval-routes"
						element={
							<ApprovalRouteManage />
						}
					/>
					<Route
						path="approval-assignments"
						element={
							<ApprovalRouteAssignments />
						}
					/>
				</Route>

				<Route
					path="/cma"
					element={
						<PrivateRoute>
							<Cma />
						</PrivateRoute>
					}
				/>

				{/* CMA Admin Route */}
				<Route
					path="/cma/admin"
					element={
						<PrivateRoute
							requiredGroups={[
								"cma_staff",
							]}>
							<AdminPage />
						</PrivateRoute>
					}
				/>

				{/* CMA Staff Bulk Enrollment Route */}
				<Route
					path="/cma/admin/enrollments/bulk"
					element={
						<PrivateRoute
							requiredGroups={[
								"cma_staff",
							]}>
							<AddBulkEnrollmentsPage />
						</PrivateRoute>
					}
				/>
				<Route
					path="/cma/admin/courses/:courseId/exam"
					element={
						<PrivateRoute
							requiredGroups={[
								"cma_staff",
							]}>
							<AdminCourseExamPage />
						</PrivateRoute>
					}
				/>
				<Route
					path="/cma/admin/courses/:courseId"
					element={
						<PrivateRoute
							requiredGroups={[
								"cma_staff",
							]}>
							<AdminCourseDetailPage />
						</PrivateRoute>
					}
				/>

				{/* CMA Video Routes */}
				<Route
					path="/cma/courses/:courseId/videos"
					element={
						<PrivateRoute>
							<CourseVideoListPage />
						</PrivateRoute>
					}
				/>
				<Route
					path="/cma/courses/:courseId/videos/:videoId"
					element={
						<PrivateRoute>
							<VideoPlayerPage />
						</PrivateRoute>
					}
				/>
				<Route
					path="/cma/courses/:courseId/exam"
					element={
						<PrivateRoute>
							<CourseExamPage />
						</PrivateRoute>
					}
				/>
			</Routes>
		</>
	);
};

const App = () => {
	return (
		<Router>
			<AppContent />
		</Router>
	);
};

export default App;
